module.exports = __webpack_public_path__ + "img/slide-1.3fc9df48.jpeg";